class Storage {
    store(key, data) {
        localStorage.setItem(key, JSON.stringify(data));
    }
    getJson(key) {
        return (JSON.parse(global.localStorage.getItem(key)));
    }
    get(key) {
        // console.log("KEY=====",key);
       return localStorage.getItem(key);
    }
    remove(key) {
        global.localStorage.removeItem(key);
    }
    clearAll() {
        global.localStorage.clear();
    }

}
export default (new Storage());
//exports();
